<template>
    <div class="edit-details">
        <router-view></router-view>

        <div class="edit-details__card">
            <icon-button @click="editcloseinfo"
                         class="edit-details__close"
            >
                close
            </icon-button>

            <div class="edit-details__main">
                <div class="edit-details__left">
                    <label for="newImgUpload">
                        <i id="neuImg" class="material-icons">add_a_photo</i>
                    </label>
                    <input id="newImgUpload" type="file" accept="image/*" style="display:none;" @change="uploadImg()">
                    <img class="editimg" :src="apiurl+'/image'+artDetails.image+'?'+nowTime" alt="">
                </div>

                <div class="edit-details__right">
                    <div class="edit-details__row">
                        <div class="edit-details__id">
                            ID: {{artDetails.id}}
                        </div>
                    </div>

                    <div class="edit-details__row">
                        <text-field label="Artikelnummer"
                                    v-model="form.artnum"
                        />
                    </div>

                    <div class="edit-details__row" v-if="!isLagerChef">
                        <div v-if="artDetails.greater100 === 1" class="greendot"></div>
                        <div v-if="artDetails.MHD === 1" class="MHD">MHD</div>
                    </div>

                    <div class="edit-details__checkboxes" v-if="isLagerChef">
                        <div class="edit-details__row">
                            <labelled-checkbox v-model="form.greater100">
                                > 100.- CHF
                            </labelled-checkbox>
                        </div>

                        <div class="edit-details__row">
                            <labelled-checkbox v-model="form.MHD">
                                MHD
                            </labelled-checkbox>
                        </div>

<!--                        <div class="edit-details__row">-->
<!--                            <labelled-checkbox v-model="form.primaer">-->
<!--                                SBB Primär-->
<!--                            </labelled-checkbox>-->
<!--                        </div>-->

                        <div class="edit-details__row">
                            <labelled-checkbox v-model="form.sekundaer">
                                SBB Sekundär
                            </labelled-checkbox>
                        </div>

                        <div class="edit-details__row">
                            <labelled-checkbox v-model="form.kuechenmat">
                                Küchenmat
                            </labelled-checkbox>
                        </div>

                        <div class="edit-details__row">
                            <labelled-checkbox v-model="form.verbrauchsMat">
                                SRM Mat
                            </labelled-checkbox>
                        </div>

                        <div class="edit-details__row">
                            <labelled-checkbox v-model="form.sfs">
                                SFS Mat
                            </labelled-checkbox>
                        </div>

                        <div class="edit-details__row">
                            <labelled-checkbox v-model="form.em">
                                EM Mat
                            </labelled-checkbox>
                        </div>

                    </div>

                    <div class="edit-details__row" v-if="isLagerChef">
                        <text-field v-model="form.shorttxt"
                                    label="Kurztext"
                                    type="textarea"
                        />
                    </div>

                    <div class="edit-details__row" v-if="!isLagerChef">
                        <div class="editShortText">
                            {{ artDetails.shorttxt }}
                        </div>
                    </div>

                    <div class="edit-details__row">
                        <text-field type="textarea"
                                    label="Infos"
                                    :rows="5"
                                    v-model="form.info"
                        />
                    </div>

                    <div class="edit-details__row" v-if="!isLagerChef">
                        <div class="editShortText">
                            {{artDetails.notiz}}
                        </div>
                    </div>

                    <div class="edit-details__row" v-if="isLagerChef">
                        <text-field label="Notiz"
                                    type="textarea"
                                    :rows="2"
                                    v-model="form.notiz"
                        />
                    </div>

                    <div class="edit-details__row">
                        <text-field label="Lagerort"
                                    v-model="form.ort"
                        />
                    </div>

                    <div v-if="isLagerChef">
                        <div class="edit-details__row">
                            <div class="editBeschreibtxt">offene Bestellmenge:</div>
                            {{artDetails.bestell}}
                        </div>

                        <div class="edit-details__row">
                            <text-field label="Mindestbestand"
                                        v-model="form.min"
                            />
                        </div>

                        <div class="edit-details__row">
                            <text-field label="Lagerkapazität"
                                        v-model="form.kapa"
                            />
                        </div>

                        <div class="edit-details__row">
                            <labelled-checkbox v-model="form.packung">
                                als Packung Bestellen
                            </labelled-checkbox>
                        </div>

                        <div class="edit-details__row">
                            <text-field :label="quantityUnit"
                                        v-model="form.mengeneinheit"
                            />
                        </div>

                        <div class="edit-details__row">
                            <text-field v-model="form.StkProEinheit"
                                        label="Stück / Einheit"
                            />
                        </div>
                    </div>

                    <div class="edit-details__row" v-if="!isLagerChef">
                        bestell: {{artDetails.bestell}}<br>
                        min: {{artDetails.min}}<br>
                        kapazität: {{artDetails.kapa}}<br>
                        Einheit: {{artDetails.mengeneinheit}}<br>
                        Stk / Einheit: {{artDetails.StkProEinheit}}<br>
                    </div>

                    <div class="edit-details__row">
                        <text-field label="Bestand"
                                    v-model="form.max"
                        />
                    </div>

                    <div class="edit-details__row edit-details__trains" @click.prevent="showTrainsSelect">
                        <div v-if="selectedTrains.length < 1" id="edithideDiv" class="edithideDiv">
                            <p class="edithideText">züge</p><br>
                        </div>
                        <div v-for="item in selectedTrains"
                             :key="item.id"
                        >
                            {{item.train}}
                        </div>
                    </div>

                    <div class="edit-details__actions">
                        <div class="edit-details__action">
                            <default-button @click="submitChanges()"
                                            :variations="['full-width']"
                            >
                                Speichern
                            </default-button>
                        </div>

                        <div class="edit-details__action">
                            <default-button v-if="autLev.indexOf('4') > -1"
                                            :variations="['danger', 'full-width']"
                                            @click="delArt()"
                            >
                                Löschen
                            </default-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import http from '../../http/http';
import IconButton from '../common/icon-button';
import DefaultButton from '../common/default-button';
import TextField from '../common/text-field';
import { mapGetters } from 'vuex';
import LabelledCheckbox from '../common/labelled-checkbox';

export default {
    components: { LabelledCheckbox, IconButton, DefaultButton, TextField },
    props: {
        artId: {
            type: String,
            default: '1'
        },
        stao: {
            type: String,
            default: '1'
        }
    },
    data() {
        return {
            form: {
                id: '',
                artnum: '',
                info: '',
                ort: '',
                stao: '',
                MHD: false,
                greater100: false,
                verbrauchsMat: false,
                sfs: false,
                em: false,
                kuechenmat: false,
                primaer: false,
                sekundaer: false,
                min: '',
                max: '',
                bes: '',
                kapa: '',
                mengeneinheit: '',
                StkProEinheit: '',
                packung: false,
                shorttxt: '',
                notiz: ''
            },
            nowTime: ''
        };
    },
    computed: {
        ...mapGetters('fotodatenbank', [
            'selectedTrains',
            'artDetails'
        ]),
        ...mapGetters('user', [
            'autLev'
        ]),
        quantityUnit() {
            if (this.form.packung) {
                return `Einzel Mengeneinheit`;
            }
            return `Mengeneinheit`;
        },
        apiurl() {
            return http.defaults.baseURL;
        },
        isLagerChef() {
            return this.autLev.indexOf(6) > -1;
        }
    },
    watch: {
        artDetails() {
            this.nowTime = (new Date()).getTime();

            Object.assign(this.form, {
                MHD: !!this.artDetails.MHD,
                StkProEinheit: this.artDetails.StkProEinheit,
                artnum: this.artDetails.artnum,
                bestell: this.artDetails.bestell,
                greater100: !!this.artDetails.greater100,
                id: this.artDetails.id,
                image: this.artDetails.image,
                info: this.artDetails.info,
                kapa: this.artDetails.kapa,
                max: this.artDetails.max,
                mengeneinheit: this.artDetails.mengeneinheit,
                min: this.artDetails.min,
                notiz: this.artDetails.notiz,
                ort: this.artDetails.ort,
                otherLager: this.artDetails.otherLager,
                packung: !!this.artDetails.packung,
                shorttxt: this.artDetails.shorttxt,
                storage: this.artDetails.storage,
                verbrauchsMat: !!this.artDetails.verbrauchsMat,
                sfs: !!this.artDetails.sfs,
                em: !!this.artDetails.em,
                kuechenmat: !!this.artDetails.kuechenmat,
                primaer: !!this.artDetails.primaer,
                sekundaer: !!this.artDetails.sekundaer,
                stao: this.stao
            });
        },
        // 'form.packung': () => {
        //     this.form.mengeneinheit = 'Stk';
        // }
        'form.verbrauchsMat'() {
            if (this.form.verbrauchsMat) {
                this.form.sfs = false;
                this.form.em = false;
                this.form.primaer = false;
                this.form.sekundaer = false;
                this.form.kuechenmat = false;
            }
        },
        'form.sfs'() {
            if (this.form.sfs) {
                this.form.verbrauchsMat = false;
                this.form.em = false;
                this.form.primaer = false;
                this.form.sekundaer = false;
                this.form.kuechenmat = false;
            }
        },
        'form.em'() {
            if (this.form.em) {
                this.form.verbrauchsMat = false;
                this.form.sfs = false;
                this.form.primaer = false;
                this.form.sekundaer = false;
                this.form.kuechenmat = false;
            }
        },
        'form.kuechenmat'() {
            if (this.form.kuechenmat) {
                this.form.em = false;
                this.form.verbrauchsMat = false;
                this.form.sfs = false;
                this.form.primaer = false;
                this.form.sekundaer = false;
            }
        },
        'form.primaer'() {
            if (this.form.primaer) {
                this.form.kuechenmat = false;
                this.form.em = false;
                this.form.verbrauchsMat = false;
                this.form.sfs = false;
                this.form.sekundaer = false;
            }
        },
        'form.sekundaer'() {
            if (this.form.sekundaer) {
                this.form.primaer = false;
                this.form.kuechenmat = false;
                this.form.em = false;
                this.form.verbrauchsMat = false;
                this.form.sfs = false;
            }
        }

    },
    methods: {
        editcloseinfo() {
            this.$router.go(-1);
        },
        showTrainsSelect() {
            this.$router.push({ name: 'editTrainSelect' });
        },
        submitChanges() {
            // console.log({ ...this.form });
            this.$store.dispatch('fotodatenbank/changeArt', { ...this.form });
        },
        uploadImg() {
            const data = {
                id: this.artDetails.id,
                artnum: this.artDetails.artnum,
                img: document.getElementById('newImgUpload').files[0]
            };

            this.$store.dispatch('fotodatenbank/uploadImg', data)
        },
        delArt() {
            this.$router.push({ name: 'delart' });
        }
    },
    created() {
        this.nowTime = (new Date()).getTime();
        this.$store.dispatch('fotodatenbank/openDetails', { id: this.artId, stao: this.stao, switch: true });
    }
}
</script>

<style scoped lang="scss">
    .edit-details__close {
        position: absolute;
        top: 1rem;
        right: 1rem;
        z-index: 100;
    }

    #neuImg {
        position: absolute;
        bottom: 1rem;
        left: 1rem;
        cursor: pointer;
        font-size: 2.5rem;
    }

    .edit-details__separator {
        border: 0;
        padding: 1px;
        clear: both;
        display: block;
        background-color: $color-black;
        height: 0.125rem;
        margin-top: 1rem;
        margin-bottom: 1rem;
    }

    .edit-details {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 999;
        width: 100%;
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .editort {
        width: 100%;
    }

    .edit-details__card {
        position: relative;
        display: flex;
        flex-direction: column;
        max-width: 100%;
        max-height: 100vh;
        background-color: $color-white;
        @include default-shadow;
        padding-top: 4rem;
        padding-left: 1rem;
        padding-right: 1rem;
        padding-bottom: 1rem;
        overflow-y: auto;

        @include extra-large {
            padding-top: 1rem;
        }
    }

    .edit-details__main {
        display: flex;
        flex-direction: column;
        width: 100%;

        @include extra-large {
            margin-top: 1rem;
        }
    }

    .edit-details__row {
        margin-bottom: 1rem;
    }

    .editinfotext {
        height: 9.5rem;
        width: 100%;
    }

    .editShortText {
        width: 100%;
    }

    .edit-details__trains {
        cursor: pointer;
    }

    .edithideDiv {
        width: 100%;
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .edithideText {
        font-size: 1.25rem;
        color: $color-gray;
        /* display:none; */
    }

    .edit-details__left {
        display: inline-block;
        position: relative;
        min-height: 100px;

        @include extra-large {
            padding-right: 1rem;
            min-width: 6.25rem;
        }
    }

    .editimg {
        max-width: 100%;
        /* max-height: 100%; */
    }

    .edit-details__actions {
        display: flex;
        flex-direction: row;
        width: 100%;
    }

    .edit-details__action {
        flex-grow: 1;

        &:first-child {
            margin-right: 0.5rem;
        }

        &:last-child {
            margin-left: 0.5rem;
        }
    }

    .saveButton {
        flex: 2;
        background-color: $color-green;
        color: $color-white;
        font-size: 1.5rem;
    }

    .train-select__delete {
        flex: 1;
        background-color: $color-red;
        color: $color-white;
        font-size: 1.5rem;

    }

    .greendot {
        border-radius: 50%;
        background-color: $color-green;
        height: 2rem;
        width: 2rem;
    }

    .MHD {
        background-color: #cc6600;
        height: 2rem;
        width: 2.5rem;
        font-size: 1rem;
        line-height: 2rem;
        padding-left: 0.125rem;
        padding-right: 0.125rem;
    }

    @include medium {
        .edit-details__card {
            width: 31rem;
        }

    }

    @include extra-large {
        #neuImg {
            top: 1rem;
        }

        .edit-details__card {
            width: auto;
            max-width: 90%;

        }

        .edit-details__main {
            flex-direction: row;
        }

        .edit-details__right {
            /* flex: 1; */
            max-width: 31rem;
            min-width: 31rem;
        }

        .editimg {
            max-width: 1000px;
            max-height: 1000px;

        }

        .editartnum {
            font-size: 2.5rem;
        }

    }

</style>
